export default __webpack_public_path__ + "static/nickname-62bbc494dce4c99c69dac9c3496f84f3.svg";